import React from 'react';
// import SommelierCatIcon from './icons/SommelierCatIcon';

// 一時的にインライン定義
const SommelierCatIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    aria-label="Cat Paw Icon"
    role="img"
    fill="currentColor"
  >
    <path d="M12 18.2c-1.45 2.08-4.5 2.08-5.95 0C4.6 16.12 6.55 13 9.1 13.6c.85.2 1.8.95 2.9 1.95c1.1-.99 2.05-1.75 2.9-1.95c2.55-.6 4.5 2.52 3.05 4.6c-1.45 2.08-4.5 2.08-5.95 0Z" />
    <circle cx="6.5" cy="10.5" r="2.3" />
    <circle cx="10.5" cy="8" r="2.3" />
    <circle cx="13.5" cy="8" r="2.3" />
    <circle cx="17.5" cy="10.5" r="2.3" />
  </svg>
);
import type { ShopProfile } from '../types';

interface CustomerPageProps {
  shopProfile: ShopProfile;
  onStart: () => void;
  onShowWineMenu: () => void;
  userId?: string;
}

const CustomerPage: React.FC<CustomerPageProps> = ({
  shopProfile,
  onStart,
  onShowWineMenu,
  userId
}) => {

  return (
    <div className="text-center">
      {shopProfile.logo ? (
        <img 
          src={shopProfile.logo} 
          alt={`${shopProfile.name || '店舗'}のロゴ`} 
          className="w-40 h-40 object-contain mx-auto mb-6 rounded-lg shadow-md bg-white p-2" 
        />
      ) : (
        <div className="mb-8 mx-auto w-fit">
          <SommelierCatIcon className="w-48 h-auto text-red-800" />
        </div>
      )}
      
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 px-4" style={{ color: 'var(--theme-text-primary, #1E293B)' }}>
        {shopProfile.name || 'AIソムリエへようこそ'}
      </h1>
      
      <p className="text-base sm:text-lg mb-8 max-w-2xl mx-auto px-4" style={{ color: 'var(--theme-text-secondary, #64748B)' }}>
        あなたにぴったりのワインを見つけます。
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center px-4 w-full max-w-md sm:max-w-none">
        <button
          onClick={onStart}
          className="bg-red-800 text-white font-bold py-3 px-6 sm:px-8 rounded-lg shadow-lg hover:bg-red-900 transition-colors duration-300 transform hover:scale-105 text-sm sm:text-base"
        >
          ワインを探す
        </button>
        <button
          onClick={() => {
            if (userId) {
              window.open(`/public-wine-list/${userId}`, '_blank');
            } else {
              alert('ログインが必要です。');
            }
          }}
          className="bg-white text-red-800 border border-red-800 font-bold py-3 px-6 sm:px-8 rounded-lg shadow-lg hover:bg-red-50 transition-colors duration-300 transform hover:scale-105 text-sm sm:text-base"
        >
          ワインリストを表示
        </button>
      </div>
      
    </div>
  );
};

export default CustomerPage;
